export default {
  // Relationships
  activity: {
    jsonApi: 'hasOne',
    type: 'activities'
  },

  // Images
  image: null,

  // Attributes
  identifier: null,
  headline: null,
  tags: [],
  course_ids: [],
  created_at: null
}
